import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import useResponsive from "../../hooks/useResponsive";

import SelectInput from "../UIElements/select";
import { FC, SetStateAction, useState } from "react";
import { ScheduleContentsTableProps } from "../../interface/schedule";
import ScheduleTable from "./Table";
import { FilterScheduleInputs } from "../FilterInputs";
import { Pagination } from "../Pagination";

const ScheduleTableContainer: FC<ScheduleContentsTableProps> = ({
  loading,
  scheduleList,
  setRefresh,
  setFilterData,
  paginationState,
  setPaginationState,
}) => {
  const theme = useTheme();
  const isSmall = useResponsive("down", "sm", "xl");
  const [open_filter, setOpen_filter] = useState(false);
  return (
    <>
      <Stack
        sx={{
          paddingX: isSmall ? 0 : 2,
          py: 2,
          mt: 2,
          background: theme.palette.common.white,
          borderRadius: "6px",
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ px: 3, py: 2 }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: 600, fontFamily: "Poppins" }}
          >
            Schedule List
          </Typography>
          <Stack
            sx={{
              color: theme.palette.primary.main,
              cursor: "pointer",
              ml: "auto",
            }}
            onClick={() => setOpen_filter(!open_filter)}
          >
            {open_filter ? <FilterAltOffIcon /> : <FilterAltIcon />}
          </Stack>
        </Stack>

        {open_filter && (
          <FilterScheduleInputs loading={false} setFilterData={setFilterData} />
        )}

        <ScheduleTable scheduleList={scheduleList} loading={loading} />
      </Stack>
      <Pagination
        paginationState={paginationState}
        setPaginationState={setPaginationState}
      />
    </>
  );
};

export default ScheduleTableContainer;
